/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Character_EyebrowInputs */

const en_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Character & Resilience`)
};

const es_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carácter y resiliencia`)
};

const de_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charakter und Belastbarkeit`)
};

const zh_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`性格与韧性`)
};

const ar_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشخصية والمرونة`)
};

const fr_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractère et résilience`)
};

const vi_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính cách và bản lĩnh`)
};

const sw_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabia & Ustahimilivu`)
};

const th_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวละครและความยืดหยุ่น`)
};

const bs_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakter i otpornost`)
};

const ja_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人格とレジリエンス`)
};

const ko_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인품과 회복력`)
};

const pt_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caráter e resiliência`)
};

const it_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carattere e resilienza`)
};

const sv_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karaktär & Resilience`)
};

const nl_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakter & veerkracht`)
};

const da_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakter og modstandskraft`)
};

const nb_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakter og motstandskraft`)
};

const fi_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luonne ja sitkeys`)
};

const pl_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charakter i odporność`)
};

const ru_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Характер и устойчивость`)
};

const tr_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakter ve Dayanıklılık`)
};

const hi_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चरित्र और लचीलापन`)
};

const id_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakter & Ketahanan`)
};

const ms_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keperibadian & Daya Tahan`)
};

const cs_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charakter & odolnost`)
};

const el_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χαρακτήρας & ανθεκτικότητα`)
};

const he_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אופי וחוסן`)
};

const af_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakter & veerkrag`)
};

const hu_about_character_eyebrow = /** @type {(inputs: About_Character_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakter és ellenálló képesség`)
};

/**
* | output |
* | --- |
* | "Character & Resilience" |
*
* @param {About_Character_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_character_eyebrow = /** @type {((inputs?: About_Character_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Character_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_character_eyebrow(inputs)
	if (locale === "de") return de_about_character_eyebrow(inputs)
	if (locale === "zh") return zh_about_character_eyebrow(inputs)
	if (locale === "ar") return ar_about_character_eyebrow(inputs)
	if (locale === "fr") return fr_about_character_eyebrow(inputs)
	if (locale === "vi") return vi_about_character_eyebrow(inputs)
	if (locale === "sw") return sw_about_character_eyebrow(inputs)
	if (locale === "th") return th_about_character_eyebrow(inputs)
	if (locale === "bs") return bs_about_character_eyebrow(inputs)
	if (locale === "ja") return ja_about_character_eyebrow(inputs)
	if (locale === "ko") return ko_about_character_eyebrow(inputs)
	if (locale === "pt") return pt_about_character_eyebrow(inputs)
	if (locale === "it") return it_about_character_eyebrow(inputs)
	if (locale === "sv") return sv_about_character_eyebrow(inputs)
	if (locale === "nl") return nl_about_character_eyebrow(inputs)
	if (locale === "da") return da_about_character_eyebrow(inputs)
	if (locale === "nb") return nb_about_character_eyebrow(inputs)
	if (locale === "fi") return fi_about_character_eyebrow(inputs)
	if (locale === "pl") return pl_about_character_eyebrow(inputs)
	if (locale === "ru") return ru_about_character_eyebrow(inputs)
	if (locale === "tr") return tr_about_character_eyebrow(inputs)
	if (locale === "hi") return hi_about_character_eyebrow(inputs)
	if (locale === "id") return id_about_character_eyebrow(inputs)
	if (locale === "ms") return ms_about_character_eyebrow(inputs)
	if (locale === "cs") return cs_about_character_eyebrow(inputs)
	if (locale === "el") return el_about_character_eyebrow(inputs)
	if (locale === "he") return he_about_character_eyebrow(inputs)
	if (locale === "af") return af_about_character_eyebrow(inputs)
	if (locale === "hu") return hu_about_character_eyebrow(inputs)
	return en_about_character_eyebrow(inputs)
});